export default __webpack_public_path__ + "static/media/download.52b0c7d4.svg";